// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme CSS variables for the onboarding flow */
:root {
  /* Primary colors */
  --primary-50: #f9ffe6;
  --primary-100: #f5ffcc;
  --primary-200: #eeff99;
  --primary-300: #e7ff66;
  --primary-400: #e1ff33;
  --primary-500: #dcff02;
  --primary-600: #b3cc02;
  --primary-700: #899901;
  --primary-800: #606c01;
  --primary-900: #363f00;

  /* Text colors */
  --text-white: #ffffff;
  --text-lightgray: #f5f5f5;
  --text-gray: #9b9b9b;
  --text-primary: var(--primary-500);

  /* Background colors */
  --bg-black: #000000;
  --bg-darkest: #0a0a0a;
  --bg-darker: #121212;
  --bg-dark: #1a1a1a;
  --bg-light: #2a2a2a;
  --bg-overlay: rgba(0, 0, 0, 0.6);
  --bg-overlay-light: rgba(0, 0, 0, 0.3);
  --bg-overlay-dark: rgba(0, 0, 0, 0.8);

  /* Border colors */
  --border-primary: rgba(220, 255, 2, 0.3);
  --border-primary-hover: rgba(220, 255, 2, 0.5);
  --border-dark: rgba(30, 41, 59, 0.8);
  --border-light: rgba(255, 255, 255, 0.1);
  --border-light-hover: rgba(255, 255, 255, 0.2);

  /* Gradients */
  --gradient-primary: linear-gradient(to right, #b3cc02, #dcff02);
  --gradient-primary-hover: linear-gradient(to right, #899901, #b3cc02);
  --gradient-section-transition: linear-gradient(
    to right,
    rgba(220, 255, 2, 0.2),
    rgba(179, 204, 2, 0.2)
  );
  --gradient-from-black: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.8),
    transparent
  );
  --gradient-to-black: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8),
    rgba(0, 0, 0, 0.6),
    transparent
  );
}

/* Class-based utility helpers */
.text-primary {
  color: var(--primary-500) !important;
}

.bg-primary {
  background-color: var(--primary-500) !important;
}

.border-primary {
  border-color: var(--border-primary) !important;
}

.border-primary-hover {
  border-color: var(--border-primary-hover) !important;
}

.bg-gradient-primary {
  background: var(--gradient-primary) !important;
}

/* Provide specific testimonial gradient classes */
.bg-gradient-testimonial-1 {
  background: linear-gradient(to right, var(--primary-500), #d4e60a) !important;
}

.bg-gradient-testimonial-2 {
  background: linear-gradient(to right, #d4e60a, #c8cc15) !important;
}

.bg-gradient-testimonial-3 {
  background: linear-gradient(to right, #c8cc15, #bdb320) !important;
}

.bg-gradient-testimonial-4 {
  background: linear-gradient(to right, #bdb320, #b29a2b) !important;
}

.bg-gradient-testimonial-5 {
  background: linear-gradient(to right, #b29a2b, #a78136) !important;
}

.bg-gradient-testimonial-6 {
  background: linear-gradient(to right, #9cc802, var(--primary-500)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/onboarding/theme/theme.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;;EAElC,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;;EAErC,kBAAkB;EAClB,wCAAwC;EACxC,8CAA8C;EAC9C,oCAAoC;EACpC,wCAAwC;EACxC,8CAA8C;;EAE9C,cAAc;EACd,+DAA+D;EAC/D,qEAAqE;EACrE;;;;GAIC;EACD;;;;GAIC;EACD;;;;;GAKC;AACH;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,kDAAkD;AAClD;EACE,6EAA6E;AAC/E;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;AAC/E","sourcesContent":["/* Theme CSS variables for the onboarding flow */\n:root {\n  /* Primary colors */\n  --primary-50: #f9ffe6;\n  --primary-100: #f5ffcc;\n  --primary-200: #eeff99;\n  --primary-300: #e7ff66;\n  --primary-400: #e1ff33;\n  --primary-500: #dcff02;\n  --primary-600: #b3cc02;\n  --primary-700: #899901;\n  --primary-800: #606c01;\n  --primary-900: #363f00;\n\n  /* Text colors */\n  --text-white: #ffffff;\n  --text-lightgray: #f5f5f5;\n  --text-gray: #9b9b9b;\n  --text-primary: var(--primary-500);\n\n  /* Background colors */\n  --bg-black: #000000;\n  --bg-darkest: #0a0a0a;\n  --bg-darker: #121212;\n  --bg-dark: #1a1a1a;\n  --bg-light: #2a2a2a;\n  --bg-overlay: rgba(0, 0, 0, 0.6);\n  --bg-overlay-light: rgba(0, 0, 0, 0.3);\n  --bg-overlay-dark: rgba(0, 0, 0, 0.8);\n\n  /* Border colors */\n  --border-primary: rgba(220, 255, 2, 0.3);\n  --border-primary-hover: rgba(220, 255, 2, 0.5);\n  --border-dark: rgba(30, 41, 59, 0.8);\n  --border-light: rgba(255, 255, 255, 0.1);\n  --border-light-hover: rgba(255, 255, 255, 0.2);\n\n  /* Gradients */\n  --gradient-primary: linear-gradient(to right, #b3cc02, #dcff02);\n  --gradient-primary-hover: linear-gradient(to right, #899901, #b3cc02);\n  --gradient-section-transition: linear-gradient(\n    to right,\n    rgba(220, 255, 2, 0.2),\n    rgba(179, 204, 2, 0.2)\n  );\n  --gradient-from-black: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.8),\n    transparent\n  );\n  --gradient-to-black: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.8),\n    rgba(0, 0, 0, 0.6),\n    transparent\n  );\n}\n\n/* Class-based utility helpers */\n.text-primary {\n  color: var(--primary-500) !important;\n}\n\n.bg-primary {\n  background-color: var(--primary-500) !important;\n}\n\n.border-primary {\n  border-color: var(--border-primary) !important;\n}\n\n.border-primary-hover {\n  border-color: var(--border-primary-hover) !important;\n}\n\n.bg-gradient-primary {\n  background: var(--gradient-primary) !important;\n}\n\n/* Provide specific testimonial gradient classes */\n.bg-gradient-testimonial-1 {\n  background: linear-gradient(to right, var(--primary-500), #d4e60a) !important;\n}\n\n.bg-gradient-testimonial-2 {\n  background: linear-gradient(to right, #d4e60a, #c8cc15) !important;\n}\n\n.bg-gradient-testimonial-3 {\n  background: linear-gradient(to right, #c8cc15, #bdb320) !important;\n}\n\n.bg-gradient-testimonial-4 {\n  background: linear-gradient(to right, #bdb320, #b29a2b) !important;\n}\n\n.bg-gradient-testimonial-5 {\n  background: linear-gradient(to right, #b29a2b, #a78136) !important;\n}\n\n.bg-gradient-testimonial-6 {\n  background: linear-gradient(to right, #9cc802, var(--primary-500)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
